import type { Mode } from "../types/api";

type SegmentedControlProps = {
  value: Mode;
  onChange: (mode: Mode) => void;
  disabled?: boolean;
};

export function SegmentedControl({ value, onChange, disabled }: SegmentedControlProps) {
  return (
    <div className="segmented" role="radiogroup" aria-label="Check mode">
      <button
        type="button"
        role="radio"
        aria-checked={value === "behavior"}
        className={value === "behavior" ? "active" : ""}
        disabled={disabled}
        onClick={() => onChange("behavior")}
      >
        A thing I&apos;m doing
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={value === "communication"}
        className={value === "communication" ? "active" : ""}
        disabled={disabled}
        onClick={() => onChange("communication")}
      >
        Words I&apos;m sending
      </button>
    </div>
  );
}
